import api from "@/lib/api";

// Convert base64url to Uint8Array (required by PushManager.subscribe)
function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = atob(base64);
  const output = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) output[i] = rawData.charCodeAt(i);
  return output;
}

let registrationPromise = null;
export async function getServiceWorkerRegistration() {
  if (!("serviceWorker" in navigator)) return null;
  if (registrationPromise) return registrationPromise;
  registrationPromise = navigator.serviceWorker
    .register("/service-worker.js")
    .catch((err) => {
      console.error("SW registration failed:", err);
      registrationPromise = null;
      return null;
    });
  return registrationPromise;
}

export async function subscribeToPush() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    return { ok: false, reason: "unsupported" };
  }
  try {
    const reg = await getServiceWorkerRegistration();
    if (!reg) return { ok: false, reason: "no-registration" };
    await navigator.serviceWorker.ready;

    // Fetch the VAPID public key from the backend
    const { data } = await api.get("/push/vapid-public-key");
    const key = data?.public_key;
    if (!key) return { ok: false, reason: "no-vapid-key" };

    // Reuse existing subscription if any
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlB64ToUint8Array(key),
      });
    }

    // Send subscription to backend
    const raw = sub.toJSON();
    await api.post("/push/subscribe", {
      endpoint: raw.endpoint,
      keys: raw.keys,
      user_agent: navigator.userAgent,
    });
    return { ok: true };
  } catch (err) {
    console.error("subscribeToPush failed:", err);
    return { ok: false, reason: err.message || "unknown" };
  }
}

export async function unsubscribeFromPush() {
  try {
    const reg = await getServiceWorkerRegistration();
    if (!reg) return;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      await api.post("/push/unsubscribe", { endpoint: sub.endpoint, keys: sub.toJSON().keys });
      await sub.unsubscribe();
    }
  } catch (err) {
    console.error("unsubscribeFromPush failed:", err);
  }
}
